import { render, staticRenderFns } from "./reservationDoctorDetail.vue?vue&type=template&id=3b4c7725&scoped=true"
import script from "./reservationDoctorDetail.vue?vue&type=script&lang=js"
export * from "./reservationDoctorDetail.vue?vue&type=script&lang=js"
import style0 from "./reservationDoctorDetail.vue?vue&type=style&index=0&id=3b4c7725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c7725",
  null
  
)

export default component.exports